import React from "react";

export default function FinalCtaSection({ onFindTeacher, onBookConsultation }) {
  return (
    <section className="bg-white" aria-labelledby="final-cta-heading">
      <div className="container mx-auto px-4 py-16 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2
            id="final-cta-heading"
            className="text-3xl font-black tracking-tight text-gray-900 md:text-4xl"
          >
            Ready to Start Your Yoga Practice?
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-gray-600">
            Find a teacher who fits your goals, experience and schedule.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={onFindTeacher}
              className="inline-flex w-full items-center justify-center rounded-lg bg-emerald-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm shadow-emerald-200 transition-colors hover:bg-emerald-700 sm:w-auto"
            >
              Find My Yoga Teacher
            </button>
            <button
              type="button"
              onClick={onBookConsultation}
              className="inline-flex w-full items-center justify-center rounded-lg border-2 border-emerald-600 bg-white px-6 py-3.5 text-sm font-semibold text-emerald-700 transition-colors hover:bg-emerald-50 sm:w-auto"
            >
              Book a Free 15-Minute Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
